(function () {
  if (window._rebuyCartFix) return;
  window._rebuyCartFix = true;

  var pendingRestore = false;
  var addHandled     = false;
  var _origFetch     = window.fetch;

  function isRebuyPopupVisible() {
    return !!document.querySelector('.rebuy-widget-container.widget-display-popup.is-visible');
  }

  function refreshSnapDrawer() {
    if (window.MylesShared && window.MylesShared.miniCartController) {
      window.MylesShared.miniCartController.reloadMiniCart(true);
    }
  }

  function getDrawerItems() {
    var items = [];
    var els = document.querySelectorAll(
      '#SnapDrawersWrapper .cart-item[data-variant-id]'
    );
    for (var i = 0; i < els.length; i++) {
      var el    = els[i];
      var vid   = parseInt(el.getAttribute('data-variant-id'), 10);
      var qtyEl = el.querySelector('.quantity_text');
      var qty   = qtyEl ? parseInt(qtyEl.textContent.trim(), 10) : 1;
      if (vid > 0) items.push({ variant_id: vid, quantity: qty > 0 ? qty : 1 });
    }
    return items;
  }

  function restoreMissingItems(drawerItems) {
    if (pendingRestore || drawerItems.length === 0) return;
    pendingRestore = true;

    _origFetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cartNow) {
        var nowIds  = cartNow.items.map(function (i) { return i.variant_id; });
        var missing = drawerItems.filter(function (i) {
          return nowIds.indexOf(i.variant_id) === -1;
        });
        if (missing.length === 0) return null;
        return _origFetch('/cart/add.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: missing.map(function (i) {
              return { id: i.variant_id, quantity: i.quantity };
            })
          })
        });
      })
      .then(function () {
        pendingRestore = false;
        refreshSnapDrawer();
      })
      .catch(function () { pendingRestore = false; });
  }

  function handleRebuyAdd() {
    if (pendingRestore || addHandled) return;
    addHandled = true;
    setTimeout(function () { addHandled = false; }, 5000);

    var drawerItems = getDrawerItems();

    setTimeout(function () {
      restoreMissingItems(drawerItems);
    }, 2000);
  }

  window.fetch = function (resource, options) {
    var url    = typeof resource === 'string' ? resource : (resource && resource.url) || '';
    var method = ((options && options.method) || 'GET').toUpperCase();
    if (method === 'POST' && url.indexOf('/cart/add.js') !== -1 && isRebuyPopupVisible()) {
      handleRebuyAdd();
    }
    return _origFetch.apply(this, arguments);
  };
  
  var _origOpen = XMLHttpRequest.prototype.open;
  var _origSend = XMLHttpRequest.prototype.send;

  XMLHttpRequest.prototype.open = function (method, url) {
    this._rMethod = method || '';
    this._rUrl    = url    || '';
    return _origOpen.apply(this, arguments);
  };

  XMLHttpRequest.prototype.send = function () {
    if (
      this._rMethod.toUpperCase() === 'POST' &&
      this._rUrl.indexOf('/cart/add.js') !== -1 &&
      isRebuyPopupVisible()
    ) {
      handleRebuyAdd();
    }
    return _origSend.apply(this, arguments);
  };
})();
